module.exports = __webpack_public_path__ + "media/exploreServices/video-6a2ccfcb.png";